import React from "react";

/**
 * Compact dashboard header - page title + optional short contextual
 * description, no breadcrumbs or decorative elements consuming vertical
 * space (the app's existing SubHeader/notifications/profile menu already
 * live in the shared layout chrome above this - see
 * frontend/src/_metronic/layout/components/Layout.js - so this component
 * intentionally does not duplicate them).
 */
export default function DashboardHeader({ title, subtitle }) {
  return (
    <div className="dashboard-header">
      <div>
        <h1 className="dashboard-header__title">{title}</h1>
        {subtitle && <p className="dashboard-header__subtitle">{subtitle}</p>}
      </div>
    </div>
  );
}
